import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecklessDriving = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Glass_washer",
	"data-name": "Glass washer",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_15451",
		"data-name": "Group 15451",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11893",
				"data-name": "Path 11893",
				d: "M7.5,13,12,22",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11894",
				"data-name": "Path 11894",
				d: "M21.289,11.473,17.475,19.1a.987.987,0,0,1-1.289.466,10.391,10.391,0,0,0-8.576,0A.988.988,0,0,1,6.32,19.1L2.507,11.473a1,1,0,0,1,.418-1.332,19.871,19.871,0,0,1,17.945,0,1,1,0,0,1,.419,1.332Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11895",
				"data-name": "Path 11895",
				d: "M17.587,2.879a3.122,3.122,0,0,0-.394-.308",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11896",
				"data-name": "Path 11896",
				d: "M14.381,2.113a3.337,3.337,0,0,0-1.423.766,3.066,3.066,0,0,0-.3.31",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				strokeDasharray: "0.586 2.932"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11897",
				"data-name": "Path 11897",
				d: "M12.045,4.5A2.767,2.767,0,0,0,12,5a2.767,2.767,0,0,0-.045-.5",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11898",
				"data-name": "Path 11898",
				d: "M10.178,2.31a3.546,3.546,0,0,0-2-.267",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				strokeDasharray: "0.586 2.932"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11899",
				"data-name": "Path 11899",
				d: "M6.807,2.57a3.225,3.225,0,0,0-.394.309",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11900",
				"data-name": "Path 11900",
				d: "M12,13V12",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				strokeDasharray: "1 5"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11901",
				"data-name": "Path 11901",
				d: "M12,9V8",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				strokeDasharray: "1 5"
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11902",
		"data-name": "Path 11902",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgRecklessDriving;
